'use client';

import React from "react";
import { PlayButton, useMediaState } from "@vidstack/react";
import { BraivLargePlayIcon, BraivPauseIcon } from "@/components/player/layouts/shared/playerIcons";
import { PlayButtonShape } from "@/lib/types";
export interface PlayerCenterPlayButtonProps {
  size: 'small' | 'medium' | 'large';
  shape?: PlayButtonShape;
}
export function LargePlayButton({
  size,
  shape = "circle"
}: PlayerCenterPlayButtonProps) {
  const isPaused = useMediaState('paused');
  const sizeClass = size === 'small' ? 'big-play-icon-small' : size === 'medium' ? 'big-play-icon-medium' : 'big-play-icon-large';
  const shapeClass = `big-play-icon-${shape}`;
  return <PlayButton className={`vds-button big-play-icon ${sizeClass} ${shapeClass} ${!isPaused && size !== 'small' ? 'slow-fade' : ''}`} data-sentry-element="PlayButton" data-sentry-component="LargePlayButton" data-sentry-source-file="PlayerCenterPlayButton.tsx">
            {isPaused ? <BraivLargePlayIcon className={"vds-icon"} /> : <BraivPauseIcon className={"vds-icon"} />}
        </PlayButton>;
}